import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "fecha-timestamp",
    standalone: false
})
export class FechaTimestampPipe implements PipeTransform {
  constructor(private readonly datePipe: DatePipe) { }

  transform(timeStamp: any): string {
    try {
      const fecha = new Date(timeStamp).toString();
      return this.datePipe.transform(fecha, "dd/MM/yyy hh:mm").concat("hrs.");
    } catch (err) {
      console.error(err);
      return timeStamp.toString();
    }
  }
}
